// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.egMx6UiRmnnODoMj6Ugi {
  padding: 8px 12px;
  border: none;
  background-color: #2c2c2c;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px !important;
  transition: background-color 0.2s;
}
.egMx6UiRmnnODoMj6Ugi:hover {
  background-color: #3c3c3c;
}
.egMx6UiRmnnODoMj6Ugi:active {
  background-color: #1c1c1c;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/UnitsPreference/UnitsPreference.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,iCAAA;AACF;AACE;EACE,yBAAA;AACJ;AAEE;EACE,yBAAA;AAAJ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unitsToggle": `egMx6UiRmnnODoMj6Ugi`
};
export default ___CSS_LOADER_EXPORT___;
